import React from 'react';

export const bgColor = '#E5E7EB';
export const modalStyle: Omit<React.CSSProperties, 'border'> & {
    bgcolor?: string;
    p?: number;
    borderRadius?: number | string;
    boxShadow?: number | string;
    display?: string | { xs?: string; sm?: string; md?: string };
    width?: string | number;
    height?: string | number;
    border?: string;
    [key: string]: any;
} = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#fff',
    boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
    borderRadius: 2,
    p: 4,
};

